import { createContext, useContext, useState, useEffect } from "react";

const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [queryParams, setQueryParams] = useState({
    category: [],
    subcategory: [],
    caseType: [],
    brand: [],
    color: [],
    price: [0, 10000],
  });
  const [productListCache, setProductListCache] = useState(null);

  useEffect(() => {
    fetch("https://jsonplaceholder.typicode.com/posts") // Replace with your API URL
      .then((response) => response.json())
      .then((result) => {
        console.log('json place resp - ', result);
        
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  return (
    <ApiContext.Provider value={{ data, loading, error, queryParams, setQueryParams, productListCache, setProductListCache }}>
      {children}
    </ApiContext.Provider>
  );
};

export const useContextData = () => {
  return useContext(ApiContext);
};
